const situacaoTributariaPis = {
  OPERACAO_TRIBUTAVEL_01:
    '01 - Operação Tributável (base de cálculo = valor da operação alíquota normal (cumulativo/não cumulativo))',
  OPERACAO_TRIBUTAVEL_02: '02 - Operação Tributável (base de cálculo = valor da operação (alíquota diferenciada))',
  OPERACAO_TRIBUTAVEL_03:
    '03 - Operação Tributável (base de cálculo = quantidade vendida x alíquota por unidade de produto)',
  OPERACAO_TRIBUTAVEL_04: '04 - Operação Tributável (tributação monofásica (alíquota zero))',
  OPERACAO_TRIBUTAVEL_05: '05 - Operação Tributável (Substituição Tributária)',
  OPERACAO_TRIBUTAVEL_06: '06 - Operação Tributável (alíquota zero)',
  OPERACAO_TRIBUTAVEL_07: '07 - Operação Isenta da Contribuição',
  OPERACAO_TRIBUTAVEL_08: '08 - Operação Sem Incidência da Contribuição',
  OPERACAO_TRIBUTAVEL_09: '09 - Operação com Suspensão da Contribuição',
  OPERACAO_TRIBUTAVEL_49: '49 - Outras Operações de Saída',
};

export default situacaoTributariaPis;
